import { baseStyle, variants } from './checkbox';

const sizes = {
  sm: {
    label: {
      fontSize: 'xs',
    },
  },
  md: {
    label: {
      fontSize: 'sm',
    },
  },
};

const radioVariants = {
  ...variants,
  /* statusGroups: {
    container: {
      bg: 'blueLight',
      borderRadius: 'full',
      px: 3,
      py: 2,
      _hover: { bg: 'campaignStatusGroups.planning' },
      cursor: 'pointer',
      userSelect: 'none',
      transition: 'background-color .2s ease, color .2s ease',
    },
    label: {
      mb: 0,
      fontSize: 'sm',
      fontWeight: 'semibold',
    },
    control: {
      boxSize: '14px',
      borderRadius: 'full',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'WPPgray.200',
      bg: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      _checked: {
        bg: 'campaignStatusGroups.planning',
        borderColor: 'campaignStatusGroups.planning',
      },
    },
  }, */
};

const defaultProps = {
  variant: 'outline',
  colorScheme: 'graphite',
  size: 'md',
};

export default {
  baseStyle,
  variants: radioVariants,
  sizes,
  defaultProps,
};
